export default "__VITE_PUBLIC_ASSET__a33f35e3__"